// Client-side TDS calculation mirroring backend/utils/incomeTax.js
const SLABS = [
  { min: 0,       max: 400000,  rate: 0 },
  { min: 400000,  max: 800000,  rate: 5 },
  { min: 800000,  max: 1200000, rate: 10 },
  { min: 1200000, max: 1600000, rate: 15 },
  { min: 1600000, max: 2000000, rate: 20 },
  { min: 2000000, max: 2400000, rate: 25 },
  { min: 2400000, max: Infinity, rate: 30 },
];

export function calculateTDSClient(annualGross) {
  if (!annualGross || annualGross <= 0) {
    return { annualTax: 0, monthlyTds: 0, taxableIncome: 0, standardDeduction: 0, rebateApplied: false, cess: 0, slabBreakdown: [] };
  }

  const standardDeduction = 75000;
  const taxableIncome = Math.max(0, annualGross - standardDeduction);
  let taxOnSlabs = 0;
  const slabBreakdown = [];

  for (const slab of SLABS) {
    if (taxableIncome <= slab.min) break;
    const taxableInSlab = Math.min(taxableIncome, slab.max) - slab.min;
    const slabTax = Math.round(taxableInSlab * slab.rate / 100);
    if (slabTax > 0) {
      slabBreakdown.push({
        range: `${(slab.min / 100000).toFixed(1)}L - ${slab.max === Infinity ? '∞' : (slab.max / 100000).toFixed(1) + 'L'}`,
        rate: slab.rate,
        taxable: taxableInSlab,
        tax: slabTax
      });
    }
    taxOnSlabs += slabTax;
  }

  let rebateApplied = false;
  if (taxableIncome <= 1200000) {
    rebateApplied = true;
    taxOnSlabs = 0;
  }

  const cess = Math.round(taxOnSlabs * 0.04);
  const annualTax = taxOnSlabs + cess;
  const monthlyTds = Math.round(annualTax / 12);

  return { annualTax, monthlyTds, taxableIncome, standardDeduction, rebateApplied, cess, slabBreakdown };
}
